var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("zcy-layout", {
    attrs: { "show-border": false },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(slotProps) {
          return [
            _c("div", { staticClass: "guide-main" }, [
              _c("div", { staticClass: "guide-header-img" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        (slotProps.envHref && slotProps.envHref.front) +
                        "/market-manage-index/#/isv/detail"
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          "https://sitecdn.zcycdn.com/zcy-front-other-upload/50350f8e423dec987bfa152656eb159a.png?x-oss-process=image/quality,Q_75/format,jpg",
                        alt: ""
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "guide-summary" }, [
                _c("div", { staticClass: "guide-present" }, [
                  _c("p", { staticClass: "guide-present-title" }, [
                    _vm._v("应用市场简介")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "guide-present-context" }, [
                    _vm._v(
                      "\n            政采云应用市场，是针对应用软件的在线交易与管理平台，政府采购领域的“App Store”。应用市场旨在汇聚优秀的第三方应用软件开发商，共同为采购单位、供应商和代理机构等政府采购参与方提供信息化解决方案。\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "guide-advantage-box" }, [
                  _c("div", { staticClass: "guide-advantage" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://sitecdn.zcycdn.com/zcy-front-other-upload/e9bfdf5666d5a58c0ce8fd60e8fe3f48.png",
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "guide-advantage-context" }, [
                      _c("p", { staticClass: "guide-advantage-title" }, [
                        _vm._v("10万+客户单位")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "guide-advantage-describe" }, [
                        _vm._v(
                          "4.6万家采购单位，6.5万家供应商已在平台上活跃交易，客户资源丰富"
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "guide-advantage" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://sitecdn.zcycdn.com/zcy-front-other-upload/1fe43babeab274491a12cad3d6b42142.png",
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "guide-advantage-context" }, [
                      _c("p", { staticClass: "guide-advantage-title" }, [
                        _vm._v("6省3市广阔市场")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "guide-advantage-describe" }, [
                        _vm._v(
                          "政采云已覆盖浙江全省，广西、重庆等5省（市）及无锡等2个地级市，还有多地正在落地洽谈"
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "guide-advantage" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://sitecdn.zcycdn.com/zcy-front-other-upload/026f7a5d55dd5b1b6188f91634553cd8.png",
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "guide-advantage-context" }, [
                      _c("p", { staticClass: "guide-advantage-title" }, [
                        _vm._v("超市化交易流程")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "guide-advantage-describe" }, [
                        _vm._v(
                          "软件采购全流程电子化，应用一次上架，全部客户可购买，避免开发商重复投标"
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "guide-advantage" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://sitecdn.zcycdn.com/zcy-front-other-upload/ee2443db6a49f014c1d6e261b38ce96e.png",
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "guide-advantage-context" }, [
                      _c("p", { staticClass: "guide-advantage-title" }, [
                        _vm._v("打通财政支付渠道")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "guide-advantage-describe" }, [
                        _vm._v(
                          "与国库支付系统无缝对接，可实现从预算管理、采购下单、合同签订、验收备案到支付结算的全流程在线操作"
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "register" }, [
                _c("div", { staticClass: "register-head" }, [
                  _c("p", { staticClass: "register-title" }, [
                    _vm._v("入驻应用市场")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "register-content" }, [
                    _vm._v("同时满足以下3个条件，即可申请入驻")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "register-container" }, [
                  _c("div", { staticClass: "register-box" }, [
                    _c("div", { staticClass: "register-box-head lazy-img" }, [
                      _c("img", {
                        attrs: {
                          "data-src":
                            "https://sitecdn.zcycdn.com/zcy-front-other-upload/6f67945d3d5eeffb3de29643a8f5a199.png?x-oss-process=image/quality,Q_75/format,jpg",
                          alt: ""
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "register-box-content" }, [
                      _c("p", [_vm._v("平台正式供应商")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "register-no" }, [_vm._v("1")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "register-triangle" })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "register-box" }, [
                    _c("div", { staticClass: "register-box-head lazy-img" }, [
                      _c("img", {
                        attrs: {
                          "data-src":
                            "https://sitecdn.zcycdn.com/zcy-front-other-upload/e54a410f1fbe60dd2a18eb2f0c04facc.png?x-oss-process=image/quality,Q_75/format,jpg",
                          alt: ""
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "register-box-content" }, [
                      _c("p", [
                        _vm._v(
                          "信用记录良好，没有被“信用中国”等网站列入失信名单"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "register-no" }, [_vm._v("2")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "register-triangle" })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "register-box" }, [
                    _c("div", { staticClass: "register-box-head lazy-img" }, [
                      _c("img", {
                        attrs: {
                          "data-src":
                            "https://sitecdn.zcycdn.com/zcy-front-other-upload/92b64411ec2079450879d388a768f5bb.png?x-oss-process=image/quality,Q_75/format,jpg",
                          alt: ""
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "register-box-content" }, [
                      _c("p", [
                        _vm._v("具有自行开发的应用软件产品，或拥有软件开发团队")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "register-no" }, [_vm._v("3")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "register-triangle" })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "guide-process lazy-img" }, [
                _c("img", {
                  attrs: {
                    "data-src":
                      "https://sitecdn.zcycdn.com/zcy-front-other-upload/a7daf1a1e5bd8cd76e9bcd419a224a9f.png?x-oss-process=image/quality,Q_75/format,jpg",
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "service" }, [
                _c("div", { staticClass: "service-head" }, [
                  _c("p", { staticClass: "service-head-title" }, [
                    _vm._v("入驻成功后，应用市场能为我提供什么？")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "service-head-content" }, [
                    _vm._v(
                      "平台提供全面支持，应用软件可轻松部署销售，应用开发商可专注于产品研发"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "service-container" }, [
                  _c("div", { staticClass: "service-box" }, [
                    _c("div", { staticClass: "service-box-icon lazy-img" }, [
                      _c("img", {
                        attrs: {
                          "data-src":
                            "https://sitecdn.zcycdn.com/zcy-front-other-upload/2b201ea05a921bf8f2d38644d9251632.png",
                          alt: ""
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "service-box-content" }, [
                      _c("p", { staticClass: "service-box-title" }, [
                        _vm._v("应用上架支持")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "service-box-describe" }, [
                        _vm._v(
                          "\n                · 应用申请、接入、发布3步上架销售\n                "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                · 应用一次上架，全场通用购买\n              "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "service-box" }, [
                    _c("div", { staticClass: "service-box-icon lazy-img" }, [
                      _c("img", {
                        attrs: {
                          "data-src":
                            "https://sitecdn.zcycdn.com/zcy-front-other-upload/e2921ad828dd812aa18294ff7f7cf06e.png",
                          alt: ""
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "service-box-content" }, [
                      _c("p", { staticClass: "service-box-title" }, [
                        _vm._v("平台技术支持")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "service-box-describe" }, [
                        _vm._v(
                          "\n                · 提供7天*24小时软件license授权验证服务\n                "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                · 平台技术中台能力沉淀赋能开发者\n              "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "service-box" }, [
                    _c("div", { staticClass: "service-box-icon lazy-img" }, [
                      _c("img", {
                        attrs: {
                          "data-src":
                            "https://sitecdn.zcycdn.com/zcy-front-other-upload/13525ef0edc9a3b8839644a3970699fa.png",
                          alt: ""
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "service-box-content" }, [
                      _c("p", { staticClass: "service-box-title" }, [
                        _vm._v("结算支付支持")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "service-box-describe" }, [
                        _vm._v(
                          "\n                · 打通政府财政性资金支付渠道\n                "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                · 提供预算合同备案支付全流程支持\n              "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "service-box" }, [
                    _c("div", { staticClass: "service-box-icon lazy-img" }, [
                      _c("img", {
                        attrs: {
                          "data-src":
                            "https://sitecdn.zcycdn.com/zcy-front-other-upload/9930edebb9b9453b2ba4fcf7de393d55.png",
                          alt: ""
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "service-box-content" }, [
                      _c("p", { staticClass: "service-box-title" }, [
                        _vm._v("安全可控的云资源")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "service-box-describe" }, [
                        _vm._v(
                          "\n                · 平台提供阿里政务云与公有云资源\n                "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                · 开发者可基于云架构开发和部署\n              "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "service-box" }, [
                    _c("div", { staticClass: "service-box-icon lazy-img" }, [
                      _c("img", {
                        attrs: {
                          "data-src":
                            "https://sitecdn.zcycdn.com/zcy-front-other-upload/24d7ce66ec0fa592d70e1052dd040503.png",
                          alt: ""
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "service-box-content" }, [
                      _c("p", { staticClass: "service-box-title" }, [
                        _vm._v("运维运营与培训支持")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "service-box-describe" }, [
                        _vm._v(
                          "\n                · 提供工单系统、智能客服转接服务\n                "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                · 提供培训服务赋能应用开发商\n              "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "service-box" }, [
                    _c("div", { staticClass: "service-box-icon lazy-img" }, [
                      _c("img", {
                        attrs: {
                          "data-src":
                            "https://sitecdn.zcycdn.com/zcy-front-other-upload/5c0d812ea59170d2addb3589782208ab.png",
                          alt: ""
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "service-box-content" }, [
                      _c("p", { staticClass: "service-box-title" }, [
                        _vm._v("推广服务")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "service-box-describe" }, [
                        _vm._v(
                          "\n                · 开发商享受资源位推广、用户推荐\n                "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                · 随政采云业务拓展推广产品至省外市场\n              "
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "guide-foot-img" }, [
                _c("p", { staticClass: "foot-img-title" }, [
                  _c("span", [_vm._v("入驻应用市场")]),
                  _vm._v(" "),
                  _c("span", [_vm._v("交付软件服务")]),
                  _vm._v(" "),
                  _c("span", [_vm._v("共创商业未来")])
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "foot-img-check",
                    attrs: {
                      href:
                        (slotProps.envHref && slotProps.envHref.front) +
                        "/market-manage-index/#/isv/detail"
                    }
                  },
                  [_vm._v("立即入驻")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "foot-img-doubt",
                    attrs: {
                      href: "https://www.wjx.top/jq/35443921.aspx",
                      target: "_blank"
                    }
                  },
                  [_vm._v("如有疑问，联系我们")]
                )
              ])
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-456cca56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-456cca56","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/guide/guide.vue
// module id = /tTo
// module chunks = 8